











































import { defineComponent, computed } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import { IconSize } from '@getaccept/lib-ui';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { ModuleName } from '@getaccept/lib-shared/src/entity/app-modules/enums/app-module';
import useBreakpoints from '@getaccept/lib-shared/src/composables/breakpoints.composable';
import CheckmarkIcon from '../assets/checkmark.svg';
import { useModulesStore } from '../../modules/store/modules.store';
import { useSidebarStore } from './store/sidebar.store';

export default defineComponent({
  name: 'ProductSwitcher',
  components: {
    CheckmarkIcon,
  },
  setup(_, { emit }) {
    const sidebarStore = useSidebarStore();
    const { compact } = storeToRefs(sidebarStore);
    const { isDealRoomModuleActive, activeModule } = storeToRefs(useModulesStore());

    const { isSmallScreenAndDown } = useBreakpoints();

    const products = computed(() => [
      {
        text: t('module_switcher_contract_room'),
        icon: 'contracts',
        type: ModuleName.Contracts,
      },
      {
        text: t('deal_room'),
        icon: 'door',
        type: ModuleName.DealRooms,
      },
    ]);

    const handleClick = (type: ModuleName) => {
      if (type === activeModule.value) {
        return;
      }
      emit('set-module-type', type);
    };

    return {
      ModuleName,
      compact,
      IconSize,
      products,
      handleClick,
      isSmallScreenAndDown,
      isDealRoomModuleActive,
      activeModule,
    };
  },
});
